import {Component} from '@angular/core';
import {ViewController} from '../../../providers/view-controller.service';

@Component({
  selector: 'page-modal-phone-panel',
  templateUrl: 'modal-phone-panel.html',
  styleUrls: ['./modal-phone-panel.scss']
})
export class ModalPhonePanelPage {

  constructor(private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}
